import { useState } from 'react';
import { useNavigate } from 'react-router';
import { namedChainsApi } from './api/named-chains-client';
import '../admin.css';

export function NamedChainCreateDialog() {
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  async function save() {
    if (!name.trim()) {
      setErr('Name is required');
      return;
    }
    setSaving(true);
    try {
      const created = await namedChainsApi.create({ name: name.trim() });
      navigate(`/admin/named-chains/${created.id}`, { replace: true });
    } catch (e: any) {
      setErr(e.message ?? 'Save failed');
      setSaving(false);
    }
  }

  return (
    <div className="admin-page">
      <h1>New Named Chain</h1>
      <div className="admin-form-content">
        <label>
          Name
          <input
            value={name}
            onChange={e => { setName(e.target.value); setErr(null); }}
            autoFocus
          />
        </label>
        {err && <div className="dialog-field-error">{err}</div>}
        <div>
          <button type="button" onClick={save} disabled={saving} className="rb-btn rb-btn-save">Save</button>
          <button type="button" onClick={() => navigate('/admin/named-chains')} className="rb-btn">Cancel</button>
        </div>
      </div>
    </div>
  );
}
